// Angular and NGRX Imports
import {Injectable} from "@angular/core";
import {
    forkJoin,
    Observable,
    Subject,
    Subscription
} from 'rxjs';
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";



import {
    CaseAddress,
    CreateCaseRequest,
    ExistingCasePopup
} from "../../classes/rest-classes/Case";
import {
    Case,
    CaseStatus
} from "src/app/ordering-platform/classes/Case";
import { Order, OrderDetail } from "src/app/ordering-platform/classes/Order";
import {Address} from "src/app/ordering-platform/classes/Address";
import {CaseAddresses} from "src/app/ordering-platform/classes/caseAddresses";
import {Product} from 'src/app/ordering-platform/classes/Product';
import {Line} from "src/app/ordering-platform/classes/Line";
import {PostAddress} from "src/app/ordering-platform/classes/PostAddress";

// Services
import {InsurancesService} from "src/app/ordering-platform/insurance-products/services/insurances.dataservice"
import {RestCaseService} from "../restService/restCaseService";

// Helpers
import {CaseFileHelper} from "src/app/ordering-platform/shared/helpers/CaseFileHelper";
import {ValidateSearch} from "src/app/ordering-platform/RegexHelpers/validatesearch.regex";
import {AddressHelperService} from "./AddressHelperService";
import {OrderHelper} from "./OrderHelper";
import {RestCasesService} from "../restService/restCasesService";
import {CreateCaseResponse} from "../../classes/rest-classes/CreateCaseResponse";


@Injectable({
    providedIn: 'root'
})

export class CaseHelperService {
    case: Case;
    caseIds: number[];
    caseRef: string;
    addresses: Address[] = [];
    showAddreses: boolean;
    searching: boolean;
    noResults: boolean;
    duplicateAddress: boolean;
    duplicateClientRef: boolean;
    clientRefPopup: boolean;
    clientRefPopupAdd: string;
    clientRefPopupDate: string;
    lawyerCheckerPopup: string;
    insuranceProducts: Product[] = [];
    caseAddress: CaseAddresses;
    exactMatch: ExistingCasePopup;
    addressSetSubject = new Subject<boolean>();
    clientRefAddressDisable = new Subject<boolean>();
    addressIsSet = this.addressSetSubject.asObservable();
    clientRefIsDisabled = this.clientRefAddressDisable.asObservable();
    duplicateAddressSub: Subscription;
    duplicateCaseRefSub: Subscription;
    existingAddress: CaseAddresses;
    caseAddressLi: CaseAddress;
    postAddress: PostAddress;
    postCodeSub: Subscription;
    matchingCaseID: number;
    matchingClientRef: string;
    isLawyerChecker: boolean = false;
    isAml: boolean = false;
    isBonds: boolean = false;

    resumeCasePopUpSubject = new Subject<boolean>();
    resumeCasePopup = this.resumeCasePopUpSubject.asObservable();
    AddressSearched: boolean;
    RouteFromNewBuildFinder: boolean;
    sortedResponses: any;
    latestResult: ExistingCasePopup;

    showSofInsuranceModal: boolean = false;

  expiredDrafts: OrderDetail[] = []

    constructor(private _router: Router,
                private addressHelper: AddressHelperService,
                private http: HttpClient,
                private _helper: CaseFileHelper,
                private _insuranceData: InsurancesService,
                private restCaseService: RestCaseService,
                private restCasesService: RestCasesService,
    ) {
    }

    /*
     * BuildNewCase
     * Function to create new case object
     */
    public BuildNewCase(reference?: string) {

        if (this.case) {
            return;
        }

        if (reference) {
            return;
        }
        this.case = new Case(this.caseRef, new Date(), [], [], CaseStatus.Incomplete, [], []);
        this.case.caseFileId = 0;
        this.case.address = new CaseAddresses('', '', '', '', 0, 0, '', '', '', '', '', '', '', '', '', 0, 0);
        this.case.Reference = this.caseRef;
        this.case.caseReference = this.caseRef;
    }


    /**
     * CreateCase
     * To be called once 'BuildNewCase' has been ran.
     * Order helper is injected with all the data transferred onto it
     * Callback goes back to a function that you have defined to where you would like to go back too
     * conext is needed to keep the current context of where you are calling this function from
     */
    public CreateCase(_orderHelper: OrderHelper, callback, context, isDraftOrder: boolean, isSaveForLater: boolean, isSearches: boolean, isExpiredDraft: boolean) {
        // Creating case first
        const self = this;
        // No Existing case passed through, so create new case
        if (!_orderHelper.existingCaseId) {
            this.createCase(this.GetCase()).subscribe(result => {
                const currentCase = this.GetCase();
                if (result.success) {
                    currentCase.caseFileId = result.caseId;
                    if (result.caseAddressId) {
                        currentCase.caseaddressid = result.caseAddressId;
                    }
                    currentCase.CaseAdd = true;
                } else {
                    currentCase.CaseAdd = false;
                    callback(this.case, null, context, false);
                }

                // If the case cant be created we refer back to the callback and stop the process.
                if (!currentCase.CaseAdd) {
                    callback(this.case, null, context, false);
                }

                // Case has been created so we re-intantiate the case object to the created one.f
                self.SetNewCreatedCase(currentCase);

                _orderHelper.initJkwDefaultLoi$().subscribe(() => {
                    // If its not a draft, then send order
                    if (!isDraftOrder) {
                        // Now we can build the order
                        _orderHelper.BuildOrder(this.GetCase(), callback, context, false);
                    } else {
                        _orderHelper.BuildDraftOrder(this.GetCase(), callback, context, isSaveForLater, isSearches);
                    }
                });
            }, error => this.CatchPromiseReject(error));
        } else {
            // Existing case passed through, so get case and create order.
            if (_orderHelper.existingCaseId === undefined) {
                callback(this.case, null, context, false);
            }

            this.restCaseService.getLiCase(_orderHelper.existingCaseId).subscribe(caseDetails => {

                caseDetails.caseaddressid = caseDetails.caseAddress[0].caseAddressId;

                self.SetNewCreatedCase(caseDetails);
                // Now we can build the order
                // If its not a draft, then send order
                caseDetails.address = this.existingAddress;

                //if creating an ORDER, but resuming expired draft
                //we set a flag on the order so  that our services know they need to replace the draft.
                //isExpiredDraft
                _orderHelper.initJkwDefaultLoi$().subscribe(() => {
                    if (!isDraftOrder) {
                        // Now we can build the order
                        _orderHelper.BuildOrder(this.GetCase(), callback, context, isExpiredDraft);
                    } else {
                        _orderHelper.BuildDraftOrder(this.GetCase(), callback, context, isSaveForLater, isSearches);
                    }
                });
            });
        }
    }


    public SetCaseRef(ref: string) {
        this.caseRef = ref;
        this.case.caseReference = this.caseRef;
        this.case.Reference = this.caseRef;
    }

    /**
     * SetCaseAddress
     * This is called from search address once an address has been found.
     */
    public SetCaseAddress(add: Address, existingCase?: boolean, addressSelected?: boolean) {
        // Close address list
        this.showAddreses = false;

        const _cAddress = new CaseAddresses(
            add.buildingname || add.buildingName,
            add.buildingnumber || add.buildingNumber,
            '',
            add.county,
            0,
            0,
            add.locality,
            add.organisation,
            add.postcode,
            add.thoroughfare || add.thoroughfareDescriptor,
            add.dependentthoroughfarename || add.dependantThoroughfareName,
            add.street,
            add.subbuildingname || add.subBuildingName,
            add.town || add.townCity,
            add.uprn,
            add.northing,
            add.easting
        );

        if (add.street && !add.thoroughfare) {
            _cAddress.thoroughfare = add.street;
        }

        _cAddress.AddressDbSourced = true;
        _cAddress.propertytype = add.propertyType;
        _cAddress.saon = add.saon;
        _cAddress.paon = add.paon;

        if (_cAddress) {
            if (this.case) this.case.address = _cAddress;
            this.existingAddress = _cAddress;
        }

        if (!existingCase && addressSelected) {
            this.duplicateAddressCheck(_cAddress, _cAddress.postcode, _cAddress.buildingnumber, _cAddress.buildingname, _cAddress.subbuildingname)
        }
    }


    public SetCaseAddressWithoutCheck(add: Address) {
        if (!add) {
            this.case?.address ? this.case.address : null;
            this.existingAddress = null;
            this.caseAddress = null;
            return;
        }

        // Close address list
        this.showAddreses = false;
        const _cAddress = new CaseAddresses(add.buildingname, add.buildingnumber, '', add.county, 0, 0,
            add.locality, add.organisation, add.postcode, add.thoroughfare, add.dependentthoroughfarename, add.street, add.subbuildingname,
            add.town ? add.town : add.towncity, add.uprn, add.northing, add.easting);
        _cAddress.propertytype = add.propertyType;

        if (_cAddress)
            _cAddress.saon = add.saon;
        _cAddress.paon = add.paon;
        this.case.address = _cAddress;
        this.existingAddress = _cAddress;
        this.caseAddress = _cAddress;
    }

    /**
     * Setaddress
     * This is called to set the adddress in the policy detail via  a subject.
     */
    public setAddressForm(setaddress: boolean) {
        this.addressSetSubject.next(setaddress);
    }

    /**
     * disableClientAddress
     * disable the form inputs when the popup is visable.
     */
    public disableClientAddress(state: boolean) {
        this.clientRefAddressDisable.next(state)
    }

    /**
     * SetCaseAddressPopup
     */
    public SetCaseAddressPopup(caseAddress: CaseAddresses) {
        this.case.address = new CaseAddresses(caseAddress.buildingname, caseAddress.buildingnumber, '', caseAddress.county, 0, 0,
            caseAddress.locality, caseAddress.organisation, caseAddress.postcode, caseAddress.thoroughfare, caseAddress.dependantthoroughfarename, caseAddress.street, caseAddress.subbuildingname,
            caseAddress.towncity, caseAddress.uprn, caseAddress.northing, caseAddress.easting);
    }

    public SearchAddress(addressSearch: any, requireEastingNorthing: boolean = false) {
        this.searching = true;
        this.noResults = false;
        this.addresses = [];

        if (ValidateSearch.isPostCode(addressSearch)) {
            // search by postcode
            if (this.postCodeSub) {
                this.postCodeSub.unsubscribe()
            }
            this.postCodeSub = this.addressHelper.searchpostcode(addressSearch, requireEastingNorthing).subscribe(
                (result) => this.listAddress(result)
            );
        } else if (ValidateSearch.IsUPRN(addressSearch)) {
            // search by uprn
            this.addressHelper.searchUprn(addressSearch, requireEastingNorthing).subscribe(
                (result) => this.listAddress(result)
            );
        } else if (ValidateSearch.isTitleInfo(addressSearch.replace(/\s/g, ""))) {
            // search by titlenumber
            this.addressHelper.searchTitleInfo(addressSearch.replace(/\s/g, ""), requireEastingNorthing).subscribe(
                (result) => this.listAddress(result)
            );
        } else {
            // no result results
            const empty: Address[] = [];
            this.listAddress(empty);
        }

    }

    /**
     * listAddress
     * Gets the addresses
     */
    public listAddress(result: Address[]) {
        if (result && result.length > 0) {
            this.addresses = [];
            this.noResults = false
            this.searching = false
            this.showAddreses = true;
            result.forEach(address => {
                this.addresses.push(address)
            })

            if (this.addresses.length > 0) {
                let getUnique = this.onlyUnique(this.addresses)
                this.addresses = getUnique
            }

            if (this.addresses[0].buildingnumber) {
                this.addresses.sort(this.buildingNumbersort);

            } else {
                this.addresses.sort();
            }

        } else {
            this.noResults = true
            this.searching = false
            this.showAddreses = false;
        }
    }


    /// This is hacky, but great so we dont care. It's doing a compare on objects to look for duplicates by turning them into strings.
    onlyUnique(addresses: Address[]) {
        const uniqueAddressArray = [];
        addresses.forEach((add, index) => {
            const found = JSON.stringify(uniqueAddressArray).indexOf(JSON.stringify(add)) > -1
            if (!found) {
                uniqueAddressArray.push(add);
            }
        })

        return uniqueAddressArray;
    }

    buildingNumbersort(a, b) {
        let aInt = parseInt(a.buildingnumber)
        let bInt = parseInt(b.buildingnumber)
        if (aInt < bInt)
            return -1;
        if (aInt > bInt)
            return 1;
        return 0;
    }

    /**
     * duplicateAddressCheck
     *  Check for duplicate address
     */
    public duplicateAddressCheck(caseAddress, postcode: string, buildingNumber: string, buildingName: string, subBuildingName: string) {
        if (this.duplicateAddressSub) {
            this.duplicateAddressSub.unsubscribe()
        }
        if (!this.clientRefPopupAdd) {
            const accountId = localStorage.getItem('accountid');
            this.restCaseService.getExistingCasesAddress(accountId, postcode, buildingName, buildingNumber, subBuildingName).subscribe((result) => this.isDuplicateAddress(caseAddress, result), (error) => this.LogError(error));
        }

    }

    /**
     * duplicateCientRef
     *  Check for duplicate Client ref
     */

    public duplicateCientRef(clientRef: string, accountId: string, accountUserId) {

        if (clientRef) {
            if (this.duplicateCaseRefSub) {
                this.duplicateCaseRefSub.unsubscribe();
            }

            this.restCaseService.duplicateClientRefCheck(accountId, clientRef, accountUserId)
                .subscribe((matchingCases) => this.isDuplicateClientRef(matchingCases, clientRef));
        }
    }


    public GetCase(): Case {
        return this.case;
    }

    public SetNewCreatedCase(_case: Case) {
        this.case = _case;
    }

    /**
     * CreateCaseProxyCall
     * This is called to create the case object itself through proxy
     */
    private createCase(_case: Case) : Observable<CreateCaseResponse> {
        _case.Reference = _case.caseReference;
        if (_case.address && !_case.address.street && _case.address.thoroughfare) {
            _case.address.street = _case.address.thoroughfare;
            _case.address.thoroughfare = '';
        }

        if (this.AddressSearched) {
            _case.address.AddressDbSourced = true;
        }

        //set the new case type
        const caseType = localStorage.getItem("caseType")
        if (caseType) {
            _case.CaseTypeId = parseInt(caseType, 10)
        }

        const request = CreateCaseRequest.fromICaseCase(_case);
        return this.restCaseService.createCase(request);
    }

    public CatchPromiseReject(data) {
    }

    // Filter the addresses based on exact matches 
    private getMatchedAddresses(caseAddress: CaseAddress, addresses: ExistingCasePopup[]): ExistingCasePopup[] {
        return addresses.filter(addr =>
            (!caseAddress.buildingname || caseAddress.buildingname === addr.buildingName) &&
            (!caseAddress.buildingnumber || caseAddress.buildingnumber === addr.buildingNumber) &&
            (!caseAddress.subbuildingname || caseAddress.subbuildingname === addr.subBuildingName) &&
            (!caseAddress.organisation || caseAddress.organisation === addr.organisation) &&
            (!caseAddress.locality || caseAddress.locality === addr.locality) &&
            (!caseAddress.thoroughfare || caseAddress.thoroughfare === addr.street) &&
            (!caseAddress.towncity || caseAddress.towncity === addr.townCity) &&
            (!caseAddress.postcode || caseAddress.postcode === addr.postCode)
        );
    }


    /**
     * isDuplicateAddress
     * Check if the the result from duplicate check returns results and set variables accordingly
     */

    public isDuplicateAddress(caseAddress: CaseAddress, result: ExistingCasePopup[]): void {

        if (result.length === 0) return;

        const matchedAddresses = this.getMatchedAddresses(caseAddress, result);

        if (matchedAddresses.length === 0) return;

        this.caseIds = matchedAddresses.map(addr => addr.caseFileId);

        const caseRequests = this.caseIds.map(id => this.restCaseService.getListOfCases(id));

        forkJoin(caseRequests).subscribe({
            next: (responses: any[]) => {
                this.sortedResponses = responses.reduce((flattenedArray, responseArray) =>
                        flattenedArray.concat(responseArray),
                    []).sort((a, b) => a.createdOn.localeCompare(b.createdOn));
            },

            complete: () => {
                const latestResult = this.sortedResponses[this.sortedResponses.length - 1];
                if (latestResult) {
                    const in6months = this.dateValidation(latestResult.createdOn);
                    this.duplicateAddress = in6months;
                    this.matchingCaseID = latestResult.caseFileId;
                    this.matchingClientRef = latestResult.caseReference;
                    this.clientRefPopupAdd = latestResult.caseReference || "NO ADDRESS";
                    this.clientRefPopupDate = this._helper.transform(latestResult.createdOn);
                    this.disableClientAddress(true);
                }
            }
        });
    }


    /**
     * isDuplicateClientRef
     * Check if the clief ref is used in another case
     */
    public isDuplicateClientRef(result: ExistingCasePopup[], clientRef: string) {
        this.exactMatch = undefined
        this.clientRefPopup = false;

        // Will need to use filter when dealing with multiple cases with duplicate names
        let exactMatches = result.filter(x => x.caseReference === clientRef)
        //sort by date get latest
        exactMatches.sort(function (a, b) {
            return a.createdOn > b.createdOn ? -1 : a.createdOn < b.createdOn ? 1 : 0;
        });
        // // Get latest match
        this.exactMatch = exactMatches[0]
        if (this.exactMatch) {
            let in6months = this.dateValidation(this.exactMatch.createdOn)
            if (in6months) {
                this.duplicateClientRef = true;
                this.setAddressForm(false)
                this.clientRefPopup = true;
                this.disableClientAddress(true);
                this.matchingCaseID = this.exactMatch.caseFileId;
                if (this.exactMatch.caseAddress !== null) {
                    this.clientRefPopupAdd = this._helper.formatAddress(this.exactMatch.caseAddress[0])
                    this.matchingClientRef = this.exactMatch.caseReference;
                } else {
                    this.clientRefPopupAdd = "NO ADDRESS"
                }
                this.clientRefPopupDate = this._helper.transform(this.exactMatch.createdOn)

            }
        }
    }

    AddNewOrder() {
        this._insuranceData.existingCaseId = this.matchingCaseID;
        this._insuranceData.addToExistingCase = true;
        if (this.matchingCaseID) {
            this.resumeCasePopUpSubject.next(true);
        }
    }

    /**
     * RemoveDraft
     * Removing Draft
     */
    RemoveDraft(line: Line): boolean {
        try {
            this.restCasesService.updateLineType(line.lineIdGuid, 4).subscribe(_ => {
            });
            return true;
        } catch (error) {
            return false;
        }
    }

    async IsLineExpired(lineGuid: string) {
        try {
            return await this.restCasesService.hasDraftExpired(lineGuid).toPromise();
        } catch (error) {
            return false;
        }
    }

    async CanDraftBeConverted(lineGuid: string) {
        try {
            let resp = await this.restCasesService.getDraftStatus(lineGuid).toPromise();
            switch (resp.draftStatusId) {
                case 3: //converted
                case 4: //deprecated
                case 0: //failed
                    return false;
                default:
                    return true;
            }
        } catch (error) {
            return false;
        }
    }


    /**
     * clientRefExactMatch
     * Checks if the client refs match exactly
     */
    public clientRefExactMatch(clientref, caseref) {
        if (clientref === caseref) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * dateValidation
     * Check if creation date if within 6 months
     */
    public dateValidation(date) {
        var b = new Date(date); //your input date here
        var d = new Date(); // today date
        d.setMonth(d.getMonth() - 6);  //subtract 6 month from current date
        if (b > d) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * CancelDuplicateModal
     * Cancel model and return to springboard
     */
    public cancelDuplicateModal() {
        this.duplicateAddress = false;
        this._router.navigate(['newcase']);
    }

    /**
     * closeDuplicateModal
     * Close the popup and return all variables to false
     */
    public closeDuplicateModal() {
        this.duplicateAddress = false;
        this.duplicateClientRef = false;
        this.clientRefPopup = false;
        this.clientRefPopupAdd = undefined;
        this.matchingCaseID = undefined;
        this.disableClientAddress(false);
    }

    /**
     * LogError
     * Console log errors from subscriptions
     */
    public LogError(error) {
    }


    public DisposeMe() {
        this.case = undefined;
        this.caseAddress = undefined;
        this.caseRef = '';
        this.existingAddress = undefined;
    }
}
